import React, { useEffect } from 'react';
import { ASSETS } from '../game/constants';

const BattleCanvas = React.forwardRef(({ agents, winner }, ref) => {
  
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d', { alpha: false });
    let renderId;

    const getVictoryInfo = (type) => {
      switch(type) {
        case 0: return { main: "石頭 統治戰場", sub: "ROCK SUPREMACY" };
        case 1: return { main: "剪刀 橫掃全軍", sub: "SCISSORS DOMINANCE" };
        case 2: return { main: "布 掌控局勢", sub: "PAPER SOVEREIGNTY" };
        default: return { main: "戰鬥結束", sub: "CHAOS SETTLED" };
      }
    };

    const render = () => {
      const W = canvas.width;
      const H = canvas.height;
      if (W === 0 || H === 0) {
        renderId = requestAnimationFrame(render);
        return;
      }

      const RADIUS = Math.round(Math.max(10, Math.min(W, H) / 24));

      ctx.fillStyle = '#050508';
      ctx.fillRect(0, 0, W, H);
      
      // 背景網格 (稍微加深一點點可見度)
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.025)';
      ctx.lineWidth = 0.5;
      const gridSize = Math.max(30, W / 15);
      for(let x=0; x<W; x+=gridSize) { ctx.beginPath(); ctx.moveTo(x,0); ctx.lineTo(x,H); ctx.stroke(); }
      for(let y=0; y<H; y+=gridSize) { ctx.beginPath(); ctx.moveTo(0,y); ctx.lineTo(W,y); ctx.stroke(); }

      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      // 繪製角色
      for (const agent of agents) {
        ctx.save();
        ctx.translate(agent.x, agent.y);
        if (agent.glow > 0) {
          ctx.shadowColor = ASSETS.COLORS[agent.type];
          ctx.shadowBlur = agent.glow * 3;
        }
        const scale = agent.bump > 0 ? 1.3 : 1;
        ctx.scale(scale, scale);
        ctx.font = `${RADIUS * 1.6}px 'Apple Color Emoji', 'Segoe UI Emoji', sans-serif`;
        ctx.fillText(ASSETS.EMOJIS[agent.type], 0, 0);
        ctx.restore();
      }

      // 勝利畫面
      if (winner !== null) {
        ctx.save();
        ctx.fillStyle = 'rgba(3, 3, 5, 0.96)';
        ctx.fillRect(0, 0, W, H);
        
        const info = getVictoryInfo(winner);
        const winEmoji = ASSETS.EMOJIS[winner];
        
        const baseDimension = Math.min(W, H);
        const emojiSize = Math.round(baseDimension / 3.5);
        const mainFontSize = Math.round(baseDimension / 12);
        const subFontSize = Math.round(mainFontSize / 3.5);

        ctx.shadowColor = ASSETS.COLORS[winner];
        ctx.shadowBlur = 60;

        ctx.font = `bold ${emojiSize}px system-ui`;
        ctx.fillStyle = "#fff";
        const centerY = H / 2;
        ctx.fillText(winEmoji, W / 2, centerY - emojiSize * 0.35);
        
        ctx.shadowBlur = 0;

        ctx.font = `900 ${mainFontSize}px system-ui, "Microsoft JhengHei", "PingFang TC", sans-serif`;
        ctx.fillStyle = "#FFF";
        const mainTextY = centerY + emojiSize * 0.4;
        ctx.fillText(info.main, W / 2, mainTextY);

        ctx.font = `bold ${subFontSize}px system-ui`;
        ctx.fillStyle = ASSETS.COLORS[winner];
        ctx.letterSpacing = "4px";
        ctx.globalAlpha = 0.8;
        ctx.fillText(info.sub, W / 2, mainTextY + mainFontSize * 0.9);
        
        // 底部微型裝飾文字 (強化可讀性)
        ctx.font = "800 10px system-ui";
        ctx.fillStyle = "rgba(255,255,255,0.3)";
        ctx.letterSpacing = "2px";
        ctx.fillText("RPS CHAOS ENGINE: PREPARING NEXT ROUND", W / 2, H - 30);

        ctx.restore();
      }

      renderId = requestAnimationFrame(render);
    };

    render();
    return () => cancelAnimationFrame(renderId);
  }, [agents, winner, ref]);

  return (
    <canvas 
      ref={ref}
      className="w-full h-full cursor-crosshair block"
      style={{ touchAction: 'none' }}
    />
  );
});

BattleCanvas.displayName = 'BattleCanvas';

export default BattleCanvas;